export default state => state.category.isEarlyAccess;
